var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-tab withdraw-account-v2" },
    [
      _c("ManageBankAccountManageTabDialog", {
        attrs: {
          "member-info": _vm.memberInfo,
          "target-info": _vm.targetInfo,
          "is-active": _vm.isActive,
          "reset-key": _vm.resetKey,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }